import { Table, TableColumnsType, TableProps } from 'antd';
import dayjs from 'dayjs';
import React, { FC } from 'react'

type Props = {
    multiTranList: any
    setSelectedRowKeys: (val: any) => void
    selectedRowKeys: any
    id: any
    disableCheck?: any
}
type TableRowSelection<T extends object = object> = TableProps<T>['rowSelection'];

export const VerifiedTable: FC<Props> = (props) => {
    const column: TableColumnsType<any> = [
        {
            title: 'Toll Plaza',
            dataIndex: 'toll_plaza',
            render: (value: any, record: any, i: number) => {
                return <span style={{
                    fontSize: "12px",
                    textTransform: "capitalize"
                }}>
                    {record.toll_plaza ==="Unknown" ? "New Plaza" :record.toll_plaza}
                </span>
            },
        },
        {
            title: 'Transaction ID',
            dataIndex: 'transaction_id',
            render: (value: any, record: any, i: number) => {
                return <span style={{
                    fontSize: "12px",
                }}>{record.transaction_id} </span>
            },
            ellipsis: true,
        },
        {
            title: 'Transaction Date',
            dataIndex: 'transaction_date_time',
            render: (value: any, record: any, i: number) => {
                return <span style={{
                    fontSize: "12px"
                }}>{dayjs(value).format('DD/MM/YYYY HH:mm:ss')}</span>
            },

        },
        {
            title: 'Transaction Amount',
            dataIndex: 'transaction_amount',
            key: 'transaction_amount',
            render: (value: any, record: any, i: number) => {
                return <span style={{
                    fontSize: "12px"
                }}>{value.amount} {value.currency_symbol}</span>
            },
        },
    ];



    const onSelectChange = (newSelectedRowKeys: any) => {
        props.setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection: TableRowSelection<any> = {

        selectedRowKeys: props.selectedRowKeys,
        onChange: onSelectChange,
        hideSelectAll: true,
        getCheckboxProps: (record: any) => ({
            disabled: props.disableCheck || record.transaction_id === props.id,
        }),
        selections: [
            Table.SELECTION_INVERT,
            Table.SELECTION_NONE,

            {
                key: 'odd',
                text: 'Select Odd Rows',
                onSelect: (changeableRowKeys) => {
                    const newSelectedRowKeys = changeableRowKeys.filter((key: any) => key % 2 === 1);
                    props.setSelectedRowKeys(newSelectedRowKeys);
                },
            },
            {
                key: 'even',
                text: 'Select Even Rows',
                onSelect: (changeableRowKeys) => {
                    const newSelectedRowKeys = changeableRowKeys.filter((key: any) => key % 2 === 0);
                    props.setSelectedRowKeys(newSelectedRowKeys);
                },
            },
        ],

    };

    // useEffect(() => {
    //     if (props.id) {
    //         const matched = props.multiTranList
    //             .map((item: any) => item.transaction_id)
    //             .filter((id: any) => id === props.id);

    //         props.setSelectedRowKeys(matched);
    //     }
    // }, [props.id, props.multiTranList]);

    return (
        <div>
            <Table<any>
                pagination={false}
                rowSelection={rowSelection}
                columns={column}
                dataSource={props.multiTranList.map((item: any, index: number) => ({
                    ...item,
                    key: item

                }))}


            />
        </div>
    )
}

